<br />
<br />
<div class="row">
  <div class="col-md-2"></div>
  <div class="col-md-8 col-12">
    <div class="jumbotron">
      <h1 class="display-4">Something went wrong!</h1>
      <p class="lead">This is a managed error handled by the application.</p>
      <hr class="my-4">
      <p>*If this issue persist please contact support.</p>
      <button type="button" class="btn btn-primary"
              [routerLink]='["/home/actions"]'>
        Return Home
      </button>
    </div>
  </div>
</div>
